(function () {
    'use strict';

    angular
        .module('Lavpop-store.components')
        .controller('OauthCallbackController', OauthCallbackController);

    /** @ngInject */
    function OauthCallbackController(sweetAlert, $state, $window, $location, $rootScope, MeService, AuthenticationService, ROUTES, LOCAL_STORAGE_ITEMS) {
        const storage = new CrossStorageClient(`${ROUTES.CENTRAL_CONTAS}hub.html`);
        const queryStrings = $location.search();

        // Authentication with cross storage
        const initializeCrossStorage = () => {
            storage
                .onConnect()
                .then(() => {
                    return storage.get(
                        LOCAL_STORAGE_ITEMS.ACCESS_TOKEN,
                        LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH,
                        LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION,
                        LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_OWNER
                    );
                })
                .then(data => {
                    handleAccess(...data);
                })
                .catch(() => {
                    clearStorages();
                    errorModal('Não foi possível recuperar seu token de acesso, tente novemente!');
                });
        };

        const handleAccess = (accessToken, refreshToken, expiration, accessTokenOwner) => {
            const tokenIsExpiring = moment(expiration).diff(moment(), 'hours') < 2;

            if (!accessToken && !refreshToken) {
                AuthenticationService.logout(false, true);
                return;
            }

            if (tokenIsExpiring) {
                getNewAccessToken(refreshToken, accessTokenOwner);
            } else {
                getUserByAccessToken(accessToken, refreshToken, expiration);
            }
        };

        const getUserByAccessToken = (accessToken, refreshToken, expiration) => {
            if (angular.ISSAFARI) {
                accessToken = queryStrings.access_token;
                refreshToken = queryStrings.refresh_token;
                expiration = moment().add(queryStrings.expires_in, 'seconds').format('YYYY-MM-DD HH:mm:ss');
            }

            if (accessToken) {
                localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN, accessToken);
                localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH, refreshToken);

                MeService
                    .getMe()
                    .then(success => {
                        if (success) {
                            localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION, expiration);
                            localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_OWNER, success.Id);
                            $state.go('app.home');
                        } else {
                            clearStorages();
                            errorModal('Ocorreu um problema ao recuperar seus dados, tente novamente!');
                        }
                    }, error => {
                        clearStorages();

                        if (error.data && error.data.ErrorCode == 409)
                            errorModal(error.data.ErrorMessage);
                        else
                            errorModal('Ocorreu um problema ao recuperar seu dados, tente novamente!');
                    });
            } else {
                clearStorages();
                errorModal('Não foi possível recuperar seu token de acesso, tente novemente!');
            }
        };

        const getNewAccessToken = (refreshToken, accessTokenOwner) => {
            if (!refreshToken || !accessTokenOwner) {
                AuthenticationService.logout(false, true);
                return;
            }

            MeService
                .refreshToken(refreshToken, accessTokenOwner)
                .then(success => {
                    if (success) {
                        const tokenData = success.data;

                        // localStorage
                        localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN, tokenData.access_token);
                        localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH, tokenData.refresh_token);
                        localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION, moment().add(tokenData.expires_in, 'seconds').format('YYYY-MM-DD HH:mm:ss'));

                        // 5àccess localStorage
                        storage.set(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN, tokenData.access_token);
                        storage.set(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH, tokenData.refresh_token);
                        storage.set(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION, moment().add(tokenData.expires_in, 'seconds').format('YYYY-MM-DD HH:mm:ss'));

                        $state.go('app.home');
                    } else {
                        clearStorages();
                        AuthenticationService.logout(false, true);
                    }
                }, () => {
                    clearStorages();
                    AuthenticationService.logout(false, true);
                });
        };

        // Helper functions
        const errorModal = text => {
            sweetAlert.swal({
                title: 'Ocorreu um erro',
                text: text,
                type: 'warning',
                confirmButtonText: 'Tentar novamente',
                showCancelButton: true,
                cancelButtonText: 'Sair',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value)
                    $window.location.reload();
                else
                    $window.location.href = ROUTES.CENTRAL_CONTAS;
            })
        };

        const clearStorages = () => {
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_OWNER);
        };

        // Initialize
        const initializeOauthCallback = () => {
            if (angular.ISSAFARI)
                getUserByAccessToken();
            else
                initializeCrossStorage();

        };

        initializeOauthCallback();

        $rootScope.alignLayoutCenter = true;
    }
}());